module.exports = __webpack_public_path__ + "img/card-rempro-spelicdisc-report.de7e9d92.svg";